import { useAppDispatch, useAppSelector } from "@/store/hooks"
import {
  addHouseToProperty,
  removeHouseFromProperty,
} from "@/store/globalSlice"
import {
  canPutNewHouseOnProperty,
  canRemoveLastHouse,
} from "@/utils/propmngHelpers"
import { images } from "@/utils/data"
import { getCurrentPlayer, getMapById } from "@/utils/gameHelpers"
import classNames from "classnames"
import Color from "color"
import { useState } from "react"

interface HouseItemProps {
  index: number
  cell: ICell
}
export const HouseItem: React.FC<HouseItemProps> = ({ cell, index }) => {
  const dispatch = useAppDispatch()
  const myGame = useAppSelector((state) => state.global.myGame)
  const tempPropMngData = useAppSelector(
    (state) => state.global.tempPropMngData
  )
  const isMobile = useAppSelector((state) => state.global.isMobile)
  const propMngState = { myGame, tempPropMngData }

  const myMapId = myGame!.settings.mapId
  const myMap = getMapById(myMapId)
  const group = myMap?.groups.find(
    (group) => group.id === cell.propertyDetails?.groupId
  )
  const player = getCurrentPlayer(myGame as IGameDetails)
  const [hover, setHover] = useState(false)

  const houseData = tempPropMngData.houseData.find(
    (houseData) => houseData.propertyOrder === cell.order
  )
  const handleHouseClick = (index: number) => {
    if (houseData?.houses === index) {
      dispatch(addHouseToProperty(cell.order))
    } else {
      dispatch(removeHouseFromProperty(cell.order))
    }
  }
  if (!houseData) return null
  const isHotel = index > 3
  const canPutHouses = canPutNewHouseOnProperty(
    propMngState,
    player!.order,
    cell.order
  )
  const canRemoveHouse = canRemoveLastHouse(
    propMngState,
    player!.order,
    cell.order
  )
  const isLastHouse = houseData.houses === index + 1
  const showRemoveIcon = canRemoveHouse && isLastHouse

  if (index < houseData.houses) {
    return (
      <div
        onClick={() => showRemoveIcon && handleHouseClick(index)}
        style={{
          backgroundColor: Color(group?.color).fade(0.5).toString(),
        }}
        data-testid={`propmng.house-${cell.order}-${index}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={classNames(
          "h-11 w-11 rounded shadow-[inset_5px_5px_10px_rgba(0,0,0,0.8)] flex justify-center items-center cursor-pointer relative",
          { "w-16": isHotel }
        )}
      >
        <img
          src={isHotel ? images.hotelImage : images.houseImage}
          className={classNames(
            "h-10  transition-all duration-150 drop-shadow-[2px_4px_6px_black]  cursor-pointer",

            {
              "blur-[2px]": showRemoveIcon && hover,
              "blur-none": showRemoveIcon && !hover,
              "w-16": isHotel,
              "w-10": !isHotel,
            }
          )}
        />
        {showRemoveIcon && (
          <i
            className={classNames(
              "fa-xmark fa-solid text-red-500 fa-lg  drop-shadow-[2px_2px_2px_black] transition-all duration-150  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
              {
                "scale-100 opacity-100": hover,
                " scale-0   opacity-0": !hover,
              }
            )}
          ></i>
        )}
      </div>
    )
  }

  const currentHouses = houseData?.houses
  const showAddIcon = canPutHouses && currentHouses >= index

  return (
    <div
      onClick={() => showAddIcon && handleHouseClick(index)}
      style={{
        backgroundColor: Color(group?.color).fade(0.5).toString(),
      }}
      data-testid={`propmng.house-${cell.order}-${index}`}
      onMouseEnter={(e) => {
        if (isMobile) return
        setHover(true)
      }}
      onMouseLeave={(e) => setHover(false)}
      className={classNames(
        "h-11 w-11 rounded shadow-[inset_5px_5px_10px_rgba(0,0,0,0.8)] flex justify-center items-center cursor-pointer",
        {
          "brightness-0": !showAddIcon,
          "w-16": isHotel,
        }
      )}
    >
      <img
        src={isHotel ? images.hotelImage : images.houseImage}
        className={classNames(
          "h-10  transition-all duration-75 drop-shadow-[2px_4px_6px_black]  cursor-pointer",
          {
            "w-16": isHotel,
            "w-10": !isHotel,

            "scale-100 opacity-50": showAddIcon && hover,
            "scale-0 opacity-0": showAddIcon && !hover,
          }
        )}
      />
    </div>
  )
}
